import { useState } from "react";
import { Loader2, Youtube } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Field, inputCls } from "../Form";
import { errMsg, useApi } from "../../lib/api";

export const YouTubeBadge = ({ yt }) => {
  if (!yt) return null;
  if (yt.status === "done") return <a href={yt.url} target="_blank" rel="noreferrer" data-testid="youtube-link" className="mono text-[10px] uppercase text-[#39ff6a] hover:underline">On YouTube · {yt.privacy}</a>;
  if (yt.status === "uploading") return <span className="flex items-center gap-1 mono text-[10px] uppercase text-yellow-300" data-testid="youtube-uploading"><Loader2 className="h-3 w-3 animate-spin" /> Uploading</span>;
  return <span className="mono text-[10px] uppercase text-pink-300" title={yt.error} data-testid="youtube-failed">YouTube failed</span>;
};

export const PublishYouTube = ({ item, status, onDone }) => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: item.title.slice(0, 100), description: "", privacy: "unlisted" });
  const [busy, setBusy] = useState(false);
  const ready = status?.configured && status?.connected;
  const submit = async () => {
    setBusy(true);
    try { await api.post(`/library/${item.id}/youtube`, f); toast.success("Uploading to YouTube — this can take a few minutes"); setOpen(false); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button onClick={() => (ready ? setOpen(true) : toast.error(status?.configured ? "Connect the camp's YouTube channel on the Sales page first" : "YouTube keys aren't added yet"))}
        data-testid={`library-youtube-btn-${item.id}`} disabled={item.youtube?.status === "uploading"}
        className="flex items-center gap-1.5 rounded-[3px] border border-zinc-700 px-2.5 py-1.5 text-xs hover:border-pink-400 hover:text-pink-300 disabled:opacity-40">
        <Youtube className="h-3.5 w-3.5" /> {item.youtube?.status === "done" ? "Publish again" : "Publish"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0f0f12] border-[#2d2d38]" data-testid="youtube-publish-dialog">
          <DialogHeader><DialogTitle>Publish to {status?.channel_title || "YouTube"}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <Field label="Title"><input className={inputCls} maxLength={100} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="youtube-title-input" /></Field>
            <Field label="Description"><textarea className={inputCls} rows={3} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="youtube-description-input" /></Field>
            <Field label="Who can watch">
              <div className="flex gap-2">
                {[["unlisted", "Unlisted", "anyone with the link"], ["private", "Private", "only you on YouTube"]].map(([v, l, d]) => (
                  <button key={v} onClick={() => setF({ ...f, privacy: v })} data-testid={`youtube-privacy-${v}`}
                    className={`flex-1 rounded-[3px] border px-3 py-2 text-left transition-colors ${f.privacy === v ? "border-yellow-400 bg-yellow-400/10" : "border-zinc-800 hover:border-zinc-600"}`}>
                    <p className="text-sm font-semibold">{l}</p><p className="text-xs text-zinc-400">{d}</p>
                  </button>
                ))}
              </div>
            </Field>
            <button onClick={submit} disabled={busy || !f.title.trim()} data-testid="youtube-publish-submit"
              className="w-full flex items-center justify-center gap-2 rounded-[3px] bg-pink-500 py-2.5 font-bold text-white hover:bg-pink-400 disabled:opacity-50">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Publish to YouTube
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
